/** 공개 마케팅 사이트 글로벌 네비 */
export const LANDING_PATH = '/landing/sgez'
/** 공개 도입·이용 문의 전용 페이지 */
export const PUBLIC_INQUIRY_PATH = '/inquiry'
/** B2B 제휴 소개 페이지와 도입 문의 앵커 */
export const B2B_PARTNERSHIP_PATH = '/b2b'
export const B2B_INQUIRY_PATH = `${B2B_PARTNERSHIP_PATH}#inquiry`
/** 예전 이름(#contact 앵커 시절). 기존 코드 import 호환용 */
export const CONTACT_HASH_PATH = PUBLIC_INQUIRY_PATH

export const marketingMainNav = [
  { to: LANDING_PATH, label: '설계EZ 소개' },
  { to: '/pricing', label: '이용요금' },
  { to: B2B_PARTNERSHIP_PATH, label: 'B2B 제휴' },
  { to: '/support/faq', label: 'FAQ' },
]
